import type { ChangelogEntry } from "../types";

/**
 * VIB-2834. Varsel når en nyere versjon er deployet enn den fanen kjører.
 */
export const VERSJONSVARSEL_2026_10: ChangelogEntry = {
  id: "2026-10-07-versjonsvarsel",
  date: "2026-10-07",
  title: "Beskjed når Revehiet er oppdatert",
  summary:
    "Står Revehiet åpent mens en ny versjon legges ut, får du et varsel med knappen «Last inn på nytt».",
  sections: [
    {
      heading: "Overalt i Revehiet",
      items: [
        {
          title: "Varselet «Revehiet er oppdatert»",
          kind: "nytt",
          body: "Revehiet sjekker om en ny versjon er ute når du går tilbake til fanen og hvert femte minutt. Siden lastes aldri inn på nytt av seg selv, og «Senere» skjuler varselet til neste versjon.",
        },
      ],
    },
  ],
};
